import { defineComponent } from 'vue';
import BaseSocials from '../../mixins/BaseSocial/BaseSocial.js';
import getSerialisedParams from '../../utils/getSerialisedParams.js';

/**
 * Hey!
 *
 * SDiaspora component used for DiasporaFoundation social network
 * @link https://diasporafoundation.org/
 * @example https://share.diasporafoundation.org/?url=https%3A%2F%2Fgithub.com%2F&title=Title/
 */
/**
 * Share parameters for link
 * @link https://share.diasporafoundation.org/about.html
 * @link https://wiki.diasporafoundation.org/FAQ_for_web_developers
 */

var SDiaspora = /* #__PURE__ */defineComponent({
  name: 'SDiaspora',
  mixins: [BaseSocials('Diaspora', {
    width: 600,
    height: 540
  })],
  computed: {
    networkURL: function networkURL() {
      var BASE_URL = 'https://share.diasporafoundation.org';
      var shareOptions = this.shareOptions;
      var url = shareOptions.url,
          title = shareOptions.title;
      var serialisedParams = getSerialisedParams({
        url: url,
        title: title
      });
      return "".concat(BASE_URL).concat(serialisedParams);
    }
  },
  render: function render() {
    return this.generateComponent(this.networkURL);
  }
});

export default SDiaspora;
